// created because issue with tests on karma
// when usesing window.location.replace like function reload page and perform all tests again
// also cant create spy on such functions


const WindowProxy = {
  location: {
    set href (val) {
      if (window.isTest) return;

      return window.location.href = val;
    },

    get origin() {
      if (window.isTest) return;

      return window.location.origin;
    },

    replace: function replaceProxy (...args) {
      if (window.isTest) return;

      return window.location.replace(...args);
    },

    reload: function reloadProxy () {
      if (window.isTest) return;

      return window.location.reload();
    },

    assign: function assignProxy (...args) {
      if (window.isTest) return;

      return window.location.assign(...args);
    },
  }
};

export default WindowProxy;

